import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BsArrowUpRight, BsFillCheckCircleFill } from 'react-icons/bs';
import { IoIosArrowDown } from 'react-icons/io';
import '../Styles/ProjectSection.css'

const Project = (props) => {
    const [showInfo, setShowInfo] = useState(false)
    const { _id, projectThumbnail, projectName, paragraph, technologies } = props.project
    // useParams(_id)?
    const dynamicURL = `project/${projectName.replace(/ /g, "-")}`
    const navigate = useNavigate()
    return (
        <div>
            <article className='project__card'>
                <div id='projectImg' className='project__thumb' style={{ position: "relative" }}>
                    <img onClick={() => navigate(dynamicURL)} src={projectThumbnail} alt="" />
                </div>
                <div id='projectDetail'>
                    <h1 className='projectTitle' onClick={() => navigate(dynamicURL)}>{projectName}</h1>

                    <p className='project__description'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aut fugiat, amet cupiditate deserunt illo assumenda illum suscipit dicta adipisci optio tempora rem doloremque vero impedit maxime odit fuga dignissimos repellendus!</p>

                    <div className="technologiesList">
                        <ul>
                            {
                                technologies.map(tech => <li><BsFillCheckCircleFill className='listIcon' />
                                    <span>{tech}</span>
                                </li>)
                            }
                        </ul>
                    </div>
                    <div style={{ width: "30px", position: "absolute", right: "10px", bottom: '0' }}>
                        <BsArrowUpRight onClick={() => navigate(dynamicURL)} className='arrow__button' color='white' style={{ fontSize: "40px", padding: "6px", borderRadius: "50%", backgroundColor: "#2BA6D7" }} />
                    </div>
                </div>
            </article>
        </div>
    );
};

export default Project;